import {
  REQUEST_SEARCH_SUGGESTIONS,
  RECEIVE_SEARCH_SUGGESTIONS,
  RECEIVE_SEARCH_SUGGESTIONS_ERROR,
  UPDATE_SEARCH_SUGGESTIONS_FROM_CACHE,
  UPDATE_SEARCH_QUERY,
  RESET_SEARCH,
} from './SearchBar-Actions';

const initialState = {
  isAutoSuggestionLoading: false,
  autoSuggestionResponse: [],
  autoSuggestionError: false,
  searchQuery: '',
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_QUERY: {
      return { ...initialState, searchQuery: action.payload };
    }

    case RESET_SEARCH: {
      return initialState;
    }

    case REQUEST_SEARCH_SUGGESTIONS: {
      return {
        ...initialState,
        searchQuery: action.payload && action.payload.query,
        isAutoSuggestionLoading: true,
        autoSuggestionResponse: [],
      };
    }

    case RECEIVE_SEARCH_SUGGESTIONS: {
      return { ...initialState, autoSuggestionResponse: action.payload, isAutoSuggestionLoading: false };
    }

    case UPDATE_SEARCH_SUGGESTIONS_FROM_CACHE: {
      return { ...initialState, autoSuggestionResponse: action.payload, isAutoSuggestionLoading: false };
    }

    case RECEIVE_SEARCH_SUGGESTIONS_ERROR: {
      return {
        ...initialState,
        autoSuggestionResponse: [],
        isAutoSuggestionLoading: false,
        autoSuggestionError: true,
        searchQuery: action.payload && action.payload.query,
      };
    }
    default:
      return state;
  }
};

export default Reducer;
